import { render, staticRenderFns } from "./AffiliateProgrammes.vue?vue&type=template&id=7562e1ad&scoped=true"
import script from "./AffiliateProgrammes.vue?vue&type=script&lang=js"
export * from "./AffiliateProgrammes.vue?vue&type=script&lang=js"
import style0 from "./AffiliateProgrammes.vue?vue&type=style&index=0&id=7562e1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562e1ad",
  null
  
)

export default component.exports